import { render, staticRenderFns } from "./Actions.vue?vue&type=template&id=55395cd7&"
import script from "./Actions.vue?vue&type=script&lang=ts&"
export * from "./Actions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports